import React, { Component } from 'react';

interface Props {
  
}

interface State {
  
}

class News extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      
    };
  }

  
  render() {
    return (
      <div>
        <h1>Hello from News</h1>
      </div>
    );
  }
}

export default News;